<template>
  <zone-wrapper
    v-if="fields?.scriptUrl?.value"
    :api-settings="bookTableAPISettings"
    :script-url="fields.scriptUrl.value"
    window-key="table-booking-settings-47C61"
  >
    <div id="table-booking-widget-47C61" class="book-table-widget">
      <noscript>The Booking App requires JavaScript to be enabled.</noscript>
    </div>
  </zone-wrapper>
</template>

<script setup>
import { inject } from 'vue';
import ZoneWrapper from '../ZoneWrapper/ZoneWrapper.vue';

const props = defineProps({
  fields: {
    type: Object,
    default: () => ({}),
  },
  rendering: {
    type: Object,
  },
  params: {
    type: Object,
  },
});

const jssStore = inject('jssStore');

const bookTableAPISettings = {
  env: props?.fields?.env?.value,
  apiUrl: props?.fields?.scriptApiUrl?.value,
  bookingGTMId: props?.fields?.bookingGtmId?.value,
  bookingGTMAuth: props?.fields?.bookingGtmAuth?.value,
  bookingGTMEnv: props?.fields?.bookingGtmEnv?.value,
  softOpt: props?.fields?.bookingSoftOpt?.value,
  venueId: jssStore?.sitecoreContext()?.venueId?.toString().padStart(4, '0'),
  brand: jssStore?.sitecoreContext()?.brandName,
  venueName: jssStore?.sitecoreContext()?.venueName,
  venueImage: props.fields?.venueImage?.value?.src ?? '',
  segment: jssStore?.sitecoreContext()?.segment,
  worldpayHelper:
    window?.location.protocol + '//' + window?.location.host + props?.fields?.worldpayPath?.value,
};
</script>

<style lang="scss">
@import './scss/BookTableWidget.scss';
</style>
